<template>
  <nav class="navbar simple-nav p-0">
    <b-link
        :to="{ name:'start-page' }"
    >
      <b-img
          :src="require('@/assets/custom-images/vacina-sesi-logo-azul.svg')"
      />
    </b-link>
  </nav>
</template>

<script>
import { BLink, BImg } from 'bootstrap-vue'

export default {
  components: {
    BLink,
    BImg,
  }
}
</script>

<style scoped>
.simple-nav {
  display: flex;
  justify-content: center;
}

.simple-nav img {
  margin: 60px 0 0 0;
}

@media(min-width: 768px) {
  .simple-nav {
    display: flex;
    justify-content: left;
  }

  .simple-nav img {
    margin: 60px 0 0 86px;
  }
}
</style>
